import {
    REQUEST_CLIENTS,
    RECEIVE_CLIENTS,
    UPDATE_CLIENTS,
    ERROR_CLIENTS
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'
import {loadDataRefresh} from "../../constants/constants"

export default (state = initialFetchState, action = {}) => {
    switch(action.type) {
        case REQUEST_CLIENTS:
            return {
                ...state,
                isFetching: true,
                message: '',
                errors: {}
            }
        case RECEIVE_CLIENTS:
            return {
                ...state,
                isFetching: false,
                data: action.payload,
                validUntil: loadDataRefresh.short + Date.now(),
                message: '',
            }
        case UPDATE_CLIENTS:
            const data = state.data
            let index = null
            if(data.results){
                index = data.results.findIndex(item => item.id == action.id)
                if(index > -1){
                    data.results[index] = action.payload
                }else{
                    data.results.push(action.payload)
                }
            }
            return {
                ...state,
                isFetching: false,
                data,
                errors: action.errors
            }
        case ERROR_CLIENTS:
            return {
                ...state,
                isFetching: false,
                errors: action.errors,
                message: action.errors.server || '',
            }
        default:
            return state
    }
}